import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'
import useStyles from './cta-box.styles'

const CtaBox = (props) => {
  const {
    ctaBoxText,
    ctaBoxLinkText,
    ctaBoxUrl,
    ctaBoxSubtitle,
    variant,
  } = props

  const styles = useStyles({ variant })

  return (
    <Box py={6} className={styles.root}>
      <Box className={styles.background}>
        <Box className={styles.flexLeft}>
          <Typography variant="h5" variantMapping={{ h5: 'h2' }} className={`${styles.header} ${!variant && 'primary'}`}>{ctaBoxText}</Typography>
          {ctaBoxSubtitle && <Typography variant="body1" variantMapping={{ p: 'h3' }} className={styles.subtitle}>{ctaBoxSubtitle}</Typography>}
        </Box>
        <ButtonCta className={styles.link} href={ctaBoxUrl} arrow>{ctaBoxLinkText}</ButtonCta>
      </Box>
    </Box>
  )
}

CtaBox.propTypes = {
  ctaBoxText: PropTypes.string,
  ctaBoxLinkText: PropTypes.string,
  ctaBoxUrl: PropTypes.string,
  ctaBoxSubtitle: PropTypes.string,
  variant: PropTypes.bool,
}

CtaBox.defaultProps = {}

export default CtaBox
